module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_10.a83233e7.png";